export function KnowledgeEmptyIcon({
  className = "w-6 h-6",
}: {
  className?: string;
}) {
  return (
    <svg className={className} width="200" height="120" viewBox="0 0 200 120" fill="none" xmlns="http://www.w3.org/2000/svg" >
      <g clip-path="url(#clip0_2645_29619)">
        <g filter="url(#filter0_f_2645_29619)">
          <path d="M36.4399 44.0194C35.199 43.413 35.2445 42.5612 36.5414 42.1192L81.2195 26.8929C85.3919 25.471 92.0095 25.9197 95.9411 27.8912L149.055 54.5251C152.947 56.4763 152.73 59.1808 148.571 60.5736L102.137 76.1242L36.4399 44.0194Z" fill="#666666" />
        </g>
        <path d="M27.504 41.2388L80.6446 23.2949C84.8002 21.8917 91.3554 22.3319 95.286 24.2782L154.892 53.7912C158.822 55.7374 158.64 58.4527 154.484 59.8559L101.344 77.7997L27.504 41.2388Z" fill="#A6A9BB" />
        <g filter="url(#filter1_di_2645_29619)">
          <path d="M27.504 37.2678L80.6446 19.324C84.8002 17.9208 91.3554 18.361 95.286 20.3072L154.892 49.8203C158.822 51.7665 158.64 54.4817 154.484 55.8849L101.344 73.8288L27.504 37.2678Z" fill="#CACCDC" />
        </g>
        <g filter="url(#filter2_f_2645_29619)">
          <path d="M169.613 130.218L99.0234 78.8433L141.097 55.6302L200 67.7848L169.613 130.218Z" fill="url(#paint0_linear_2645_29619)" />
        </g>
        <g filter="url(#filter3_di_2645_29619)">
          <path d="M27.504 33.7941L80.6446 15.8502C84.8002 14.447 91.3554 14.8872 95.286 16.8335L154.892 46.3465C158.822 48.2927 158.64 51.008 154.484 52.4112L101.344 70.355L27.504 33.7941Z" fill="#CFD1E0" />
        </g>
        <g filter="url(#filter4_di_2645_29619)">
          <path d="M27.504 30.8159L80.6446 12.8721C84.8002 11.4689 91.3554 11.9091 95.286 13.8553L154.892 43.3684C158.822 45.3146 158.64 48.0298 154.484 49.433L101.344 67.3769L27.504 30.8159Z" fill="#D1D2E5" />
        </g>
        <g filter="url(#filter5_i_2645_29619)">
          <path d="M29.7379 26.4411C28.6035 25.8868 28.5306 25.1166 29.5681 24.6473L76.5567 3.39537C80.5294 1.59862 87.8694 1.90834 92.1461 4.05319L153.309 34.7272C156.857 36.5065 157.031 38.947 153.716 40.4299L103.94 62.6969L29.7379 26.4411Z" fill="url(#paint1_linear_2645_29619)" />
        </g>
        <g filter="url(#filter6_ii_2645_29619)">
          <path d="M49.9413 27.1919C48.1501 26.3146 48.0163 25.0987 49.6283 24.3455L79.2161 10.5193C81.1845 9.59948 84.8927 9.74396 87.0525 10.8246L138.029 36.3307C139.789 37.2115 139.896 38.4196 138.28 39.1648L109.064 52.6344C107.105 53.5378 103.451 53.4002 101.29 52.3414L49.9413 27.1919Z" fill="white" />
        </g>
        <g filter="url(#filter7_i_2645_29619)">
          <path d="M67.9226 27.5267C66.0827 26.6455 65.9364 25.4091 67.5821 24.6499L79.1552 19.3107C81.1459 18.3923 84.8753 18.5513 87.0161 19.6459L89.4871 20.9093C91.2086 21.7895 91.2972 22.9837 89.6957 23.7219L78.2035 29.0199C76.2604 29.9157 72.6459 29.789 70.4744 28.7489L67.9226 27.5267Z" fill="url(#paint2_linear_2645_29619)" />
        </g>
        <g filter="url(#filter8_i_2645_29619)">
          <path d="M81.7868 34.9498C79.9876 34.0881 79.8027 32.883 81.3523 32.1178L92.4615 26.6322C94.4157 25.6673 98.2339 25.8066 100.416 26.9226L102.853 28.1687C104.535 29.0286 104.663 30.1918 103.158 30.9356L92.1325 36.3825C90.225 37.3248 86.523 37.2182 84.3077 36.1572L81.7868 34.9498Z" fill="url(#paint3_linear_2645_29619)" />
        </g>
        <g filter="url(#filter9_i_2645_29619)">
          <path d="M101.806 77.1277C98.2551 71.5559 100.571 66.0665 104.173 62.3953C104.416 62.148 104.353 61.7316 104.042 61.5788L30.9737 25.6689C29.5698 24.979 27.8477 25.1456 26.8169 26.3223C21.2584 32.6678 25.0729 39.72 28.1701 42.2884L101.113 77.9689C101.573 78.1938 102.082 77.5593 101.806 77.1277Z" fill="url(#paint4_linear_2645_29619)" />
        </g>
      </g>
      <defs>
        <filter id="filter0_f_2645_29619" x="29.9284" y="20.4523" width="127.519" height="61.2817" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.8049" result="effect1_foregroundBlur_2645_29619" />
        </filter>
        <filter id="filter1_di_2645_29619" x="26.5691" y="18.5033" width="132.09" height="57.1954" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.934966" />
          <feGaussianBlur stdDeviation="0.467483" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2645_29619" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2645_29619" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1.86993" />
          <feGaussianBlur stdDeviation="0.934966" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2645_29619" />
        </filter>
        <filter id="filter2_f_2645_29619" x="95.2836" y="51.8904" width="108.456" height="82.0673" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1.86993" result="effect1_foregroundBlur_2645_29619" />
        </filter>
        <filter id="filter3_di_2645_29619" x="26.5691" y="15.0295" width="132.09" height="57.1954" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.934966" />
          <feGaussianBlur stdDeviation="0.467483" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2645_29619" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2645_29619" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1.86993" />
          <feGaussianBlur stdDeviation="0.934966" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2645_29619" />
        </filter>
        <filter id="filter4_di_2645_29619" x="26.5691" y="12.0514" width="132.09" height="57.1954" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.934966" />
          <feGaussianBlur stdDeviation="0.467483" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2645_29619" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2645_29619" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1.86993" />
          <feGaussianBlur stdDeviation="0.934966" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2645_29619" />
        </filter>
        <filter id="filter5_i_2645_29619" x="28.8359" y="2.224" width="139.855" height="62.5729" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="12.6001" dy="2.10001" />
          <feGaussianBlur stdDeviation="6.30003" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2645_29619" />
        </filter>
        <filter id="filter6_ii_2645_29619" x="48.5031" y="9.91235" width="103.521" height="45.4202" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="12.6001" dy="2.10001" />
          <feGaussianBlur stdDeviation="6.30003" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2645_29619" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.934966" />
          <feGaussianBlur stdDeviation="0.467483" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="effect1_innerShadow_2645_29619" result="effect2_innerShadow_2645_29619" />
        </filter>
        <filter id="filter7_i_2645_29619" x="66.4388" y="18.712" width="37.0012" height="13.006" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="12.6001" dy="2.10001" />
          <feGaussianBlur stdDeviation="6.30003" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2645_29619" />
        </filter>
        <filter id="filter8_i_2645_29619" x="80.303" y="25.9888" width="36.5035" height="13.1375" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="12.6001" dy="2.10001" />
          <feGaussianBlur stdDeviation="6.30003" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2645_29619" />
        </filter>
        <filter id="filter9_i_2645_29619" x="23.9854" y="25.2617" width="80.3361" height="54.854" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4.20002" />
          <feGaussianBlur stdDeviation="1.05" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2645_29619" />
        </filter>
        <linearGradient id="paint0_linear_2645_29619" x1="99.0234" y1="-6.07747" x2="162.312" y2="102.243" gradientUnits="userSpaceOnUse">
          <stop stop-color="#E0E1EF" />
          <stop offset="1" stop-color="#D9D9D9" stop-opacity="0" />
        </linearGradient>
        <linearGradient id="paint1_linear_2645_29619" x1="58.561" y1="14.8734" x2="77.7354" y2="71.6586" gradientUnits="userSpaceOnUse">
          <stop stop-color="#F6F7FA" />
          <stop offset="1" stop-color="#F7F7FE" />
        </linearGradient>
        <linearGradient id="paint2_linear_2645_29619" x1="68.1773" y1="23.8498" x2="71.2956" y2="32.2528" gradientUnits="userSpaceOnUse">
          <stop stop-color="#CECFE9" />
          <stop offset="1" stop-color="#6C6C79" />
        </linearGradient>
        <linearGradient id="paint3_linear_2645_29619" x1="82.1359" y1="31.3181" x2="85.2541" y2="39.7211" gradientUnits="userSpaceOnUse">
          <stop stop-color="#9FA0BD" />
          <stop offset="1" stop-color="#3D3D47" />
        </linearGradient>
        <linearGradient id="paint4_linear_2645_29619" x1="22.5" y1="23" x2="85.9978" y2="100.766" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" />
          <stop offset="0.868141" stop-color="#CDCEDF" />
        </linearGradient>
        <clipPath id="clip0_2645_29619">
          <rect width="200" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "KnowledgeEmptyIcon";
